<div>
    <div class="flex items-center justify-center h-[70px]">
        <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium"> Draw Signature </h4>
    </div>
    <mat-dialog-content class="!pt-0">
        <div class="flex justify-center">
            <div class="flex flex-col justify-center pr-5">
                <span class="mb-1 text-xs">Pen Color</span>
                <input matInput type="color" (change)="onChangeColor()" class="penColor">
            </div>
            <div class="flex items-center !justify-center">
                <canvas #canvas [height]="pad_height" [width]="pad_width">
                </canvas>
            </div>
        </div>

        <mat-dialog-actions class="!px-0 flex !justify-center !pt-5 mb-3">
            <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">Cancel</button>
            <button mat-flat-button color="accent" class="text-primary secondary-button" (click)="clearPad()">Clear</button>
            <button mat-flat-button class="text-primary primary-button" (click)="savePad()">Save signature</button>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>